import React from 'react';
import { TCPADisclosure } from './TCPADisclosure';
interface TCPAConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
}

/**
 * OnlineCollegeGuide's own consent block.
 *
 * Delegates to TCPADisclosure so the Jornaya tagging lives in exactly one
 * place — this used to carry its own untagged markup, which meant leads from
 * the forms using it failed the certificate's disclosure checks.
 */
export function TCPAConsent({
  checked,
  onChange,
  error
}: TCPAConsentProps) {
  return <div className="mt-4 mb-6" data-id="element-920" data-mp="2yiz8r7h8i1x3">
      <TCPADisclosure checked={checked} onChange={onChange} error={error} checkboxClassName="mt-0.5 h-4 w-4 rounded border-gray-300 text-action focus:ring-action cursor-pointer flex-shrink-0" data-id="element-921" data-mp="2yfl3nrh6rely">
        By checking this box, I consent to receive emails, phone calls, and SMS
        text messages from OnlineCollegeGuide and its partner schools at the
        email address and phone number provided, including my wireless number.
        I understand these calls may be generated using automated technology,
        and that my consent is not required to use this service or to enroll in
        a program.
      </TCPADisclosure>
    </div>;
}